import { graphql } from '@gql';

export const GET_PROJECT_TASKS = graphql(`
    query GetProjectTasks($pid: ID!) {
        tasks(where: { projectID: $pid }) {
            ...TasksConnectionPartial
        }
    }
`);

export const GET_SPECIFIC_PROJECT_TASKS = graphql(`
    query GetSpecificProjectTasks(
        $pid: ID!
        $taskIDs: [ID!]
        $taskSource: TaskSource
    ) {
        tasks(where: { projectID: $pid, idIn: $taskIDs, source: $taskSource }) {
            ...TasksConnectionPartial
        }
    }
`);

export const GET_TASKS = graphql(`
    query GetTasks($where: TaskWhereInput) {
        tasks(where: $where) {
            ...TasksConnectionPartial
        }
    }
`);

export const GET_SINGLE_TASK = graphql(`
    query GetTask($id: ID!) {
        tasks(where: { id: $id }) {
            edges {
                node {
                    id
                    title
                }
            }
        }
    }
`);

export const GET_GLOBAL_TASKS = graphql(`
    query GetGlobalTasks($uid: ID!) {
        tasks(where: { assigneeID: $uid }) {
            ...TasksConnectionPartial
        }
    }
`);

export const GET_TASK_COMMENTS = graphql(`
    query GetTasksComments($tid: ID!) {
        tasks(where: { id: $tid }) {
            edges {
                node {
                    id
                    taskComments {
                        ...TasksCommentPartial
                    }
                }
            }
        }
    }
`);

export const EXPORT_TASKS = graphql(`
    query ExportProjectTasks($id: ID!, $taskIDs: [ID!]) {
        exportProjectTasks(id: $id, taskIDs: $taskIDs) {
            fileName
            content
            type
        }
    }
`);

export const GET_REQUIREMENTS_FOR_TASK = graphql(`
    query RequirementsForTask($id: ID!) {
        requirementsForTask(taskID: $id) {
            id
            name
            alias
            description
            guidance
            implementationGuidance
            standard {
                id
                name
                description
            }
            standardProfiles {
                ...StandardProfileFragment
            }
        }
    }
`);

export const GET_TASK_EVIDENCES = graphql(`
    query GetTaskEvidences($tid: ID!) {
        tasks(where: { id: $tid }) {
            edges {
                node {
                    taskEvidences {
                        id
                        kind
                        fileAsset {
                            id
                            name
                            size
                            refID
                            contentType
                            createdBy {
                                id
                                firstName
                                lastName
                            }
                        }
                        link
                        createTime
                        updateTime
                        createdBy {
                            id
                            firstName
                            lastName
                        }
                    }
                }
            }
        }
    }
`);

export const DOWNLOAD_TASK_EVIDENCE = graphql(`
    query DownloadTaskEvidence($taskEvidenceID: ID!) {
        downloadTaskEvidenceFile(taskEvidenceID: $taskEvidenceID) {
            fileName
            content
            type
        }
    }
`);
